// Generated from ./util_cohort_builder_grammar/stable/CommonLexer.g4 by ANTLR 4.13.1

import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";


export class CommonLexer extends antlr.Lexer {
    public static readonly LINE_COMMENT = 1;
    public static readonly INT = 2;
    public static readonly M = 3;
    public static readonly D = 4;
    public static readonly Y = 5;
    public static readonly DATE = 6;
    public static readonly OPEN_PAREN = 7;
    public static readonly CLOSE_PAREN = 8;
    public static readonly SEMICOLON = 9;
    public static readonly COMMA = 10;
    public static readonly EQ = 11;
    public static readonly MULTIPLY = 12;
    public static readonly DIVIDE = 13;
    public static readonly ADD = 14;
    public static readonly SUBTRACT = 15;
    public static readonly CONTAINS = 16;
    public static readonly NEQ = 17;
    public static readonly LTE = 18;
    public static readonly GTE = 19;
    public static readonly LT = 20;
    public static readonly GT = 21;
    public static readonly MAX = 22;
    public static readonly MIN = 23;
    public static readonly AVG = 24;
    public static readonly COUNT = 25;
    public static readonly LEAST = 26;
    public static readonly GREATEST = 27;
    public static readonly IN = 28;
    public static readonly AND = 29;
    public static readonly OR = 30;
    public static readonly NOT = 31;
    public static readonly COMPLEMENT = 32;
    public static readonly UNION = 33;
    public static readonly INTERSECTION = 34;
    public static readonly DIFFERENCE = 35;
    public static readonly INDEX = 36;
    public static readonly TIME_UNIT = 37;
    public static readonly DAYS = 38;
    public static readonly WEEKS = 39;
    public static readonly MONTHS = 40;
    public static readonly YEARS = 41;
    public static readonly MINIMUM_BETWEEN = 42;
    public static readonly MAXIMUM_BETWEEN = 43;
    public static readonly TOTAL_BETWEEN = 44;
    public static readonly FIXED_WINDOW = 45;
    public static readonly ROLLING_WINDOW = 46;
    public static readonly PERIOD = 47;
    public static readonly WS = 48;

    public static readonly channelNames = [
        "DEFAULT_TOKEN_CHANNEL", "HIDDEN"
    ];

    public static readonly literalNames = [
        null, null, null, null, null, null, null, "'('", "')'", "';'", "','", 
        "'='", "'*'", "'/'", "'+'", "'-'", "'CONTAINS'", "'!='", "'<='", 
        "'>='", "'<'", "'>'", "'MAX'", "'MIN'", "'AVG'", "'COUNT'", "'LEAST'", 
        "'GREATEST'", "'IN'", "'AND'", "'OR'", "'NOT'", "'COMPLEMENT'", 
        "'UNION'", "'INTERSECTION'", "'DIFFERENCE'", "'INDEX'", null, "'DAYS'", 
        "'WEEKS'", "'MONTHS'", "'YEARS'", "'MINIMUM_BETWEEN'", "'MAXIMUM_BETWEEN'", 
        "'TOTAL_BETWEEN'", "'FIXED_WINDOW'", "'ROLLING_WINDOW'", "'.'"
    ];

    public static readonly symbolicNames = [
        null, "LINE_COMMENT", "INT", "M", "D", "Y", "DATE", "OPEN_PAREN", 
        "CLOSE_PAREN", "SEMICOLON", "COMMA", "EQ", "MULTIPLY", "DIVIDE", 
        "ADD", "SUBTRACT", "CONTAINS", "NEQ", "LTE", "GTE", "LT", "GT", 
        "MAX", "MIN", "AVG", "COUNT", "LEAST", "GREATEST", "IN", "AND", 
        "OR", "NOT", "COMPLEMENT", "UNION", "INTERSECTION", "DIFFERENCE", 
        "INDEX", "TIME_UNIT", "DAYS", "WEEKS", "MONTHS", "YEARS", "MINIMUM_BETWEEN", 
        "MAXIMUM_BETWEEN", "TOTAL_BETWEEN", "FIXED_WINDOW", "ROLLING_WINDOW", 
        "PERIOD", "WS"
    ];

    public static readonly modeNames = [
        "DEFAULT_MODE",
    ];

    public static readonly ruleNames = [
        "LINE_COMMENT", "INT", "M", "D", "Y", "DATE", "OPEN_PAREN", "CLOSE_PAREN", 
        "SEMICOLON", "COMMA", "LABEL", "ALPHA", "ALPHA_NUMERIC", "NON_ALPHA_NUMERIC", 
        "SPECIAL_CHAR", "EQ", "MULTIPLY", "DIVIDE", "ADD", "SUBTRACT", "CONTAINS", 
        "NEQ", "LTE", "GTE", "LT", "GT", "MAX", "MIN", "AVG", "COUNT", "LEAST", 
        "GREATEST", "IN", "AND", "OR", "NOT", "COMPLEMENT", "UNION", "INTERSECTION", 
        "DIFFERENCE", "INDEX", "TIME_UNIT", "DAYS", "WEEKS", "MONTHS", "YEARS", 
        "MINIMUM_BETWEEN", "MAXIMUM_BETWEEN", "TOTAL_BETWEEN", "FIXED_WINDOW", 
        "ROLLING_WINDOW", "PERIOD", "WS",
    ];


    public constructor(input: antlr.CharStream) {
        super(input);
        this.interpreter = new antlr.LexerATNSimulator(this, CommonLexer._ATN, CommonLexer.decisionsToDFA, new antlr.PredictionContextCache());
    }

    public get grammarFileName(): string { return "CommonLexer.g4"; }

    public get literalNames(): (string | null)[] { return CommonLexer.literalNames; }
    public get symbolicNames(): (string | null)[] { return CommonLexer.symbolicNames; }
    public get ruleNames(): string[] { return CommonLexer.ruleNames; }

    public get serializedATN(): number[] { return CommonLexer._serializedATN; }

    public get channelNames(): string[] { return CommonLexer.channelNames; }

    public get modeNames(): string[] { return CommonLexer.modeNames; }

    public static readonly _serializedATN: number[] = [
        4,0,48,411,6,-1,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,
        2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,12,2,
        13,7,13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,
        19,2,20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,2,
        26,7,26,2,27,7,27,2,28,7,28,2,29,7,29,2,30,7,30,2,31,7,31,2,32,7,
        32,2,33,7,33,2,34,7,34,2,35,7,35,2,36,7,36,2,37,7,37,2,38,7,38,2,
        39,7,39,2,40,7,40,2,41,7,41,2,42,7,42,2,43,7,43,2,44,7,44,2,45,7,
        45,2,46,7,46,2,47,7,47,2,48,7,48,2,49,7,49,2,50,7,50,2,51,7,51,2,
        52,7,52,1,0,1,0,1,0,1,0,5,0,112,8,0,10,0,12,0,115,9,0,1,0,1,0,1,
        1,4,1,120,8,1,11,1,12,1,121,1,2,1,2,1,2,1,2,3,2,128,8,2,1,3,1,3,
        1,3,1,3,1,3,1,3,3,3,136,8,3,1,4,1,4,1,4,1,4,1,4,1,5,1,5,1,5,1,5,
        1,5,1,5,1,6,1,6,1,7,1,7,1,8,1,8,1,9,1,9,1,10,1,10,1,10,1,10,4,10,
        161,8,10,11,10,12,10,162,1,10,1,10,1,11,1,11,1,12,1,12,3,12,171,
        8,12,1,13,1,13,1,14,1,14,1,15,1,15,1,16,1,16,1,17,1,17,1,18,1,18,
        1,19,1,19,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,21,1,21,
        1,21,1,22,1,22,1,22,1,23,1,23,1,23,1,24,1,24,1,25,1,25,1,26,1,26,
        1,26,1,26,1,27,1,27,1,27,1,27,1,28,1,28,1,28,1,28,1,29,1,29,1,29,
        1,29,1,29,1,29,1,30,1,30,1,30,1,30,1,30,1,30,1,31,1,31,1,31,1,31,
        1,31,1,31,1,31,1,31,1,31,1,32,1,32,1,32,1,33,1,33,1,33,1,33,1,34,
        1,34,1,34,1,35,1,35,1,35,1,35,1,36,1,36,1,36,1,36,1,36,1,36,1,36,
        1,36,1,36,1,36,1,36,1,37,1,37,1,37,1,37,1,37,1,37,1,38,1,38,1,38,
        1,38,1,38,1,38,1,38,1,38,1,38,1,38,1,38,1,38,1,38,1,39,1,39,1,39,
        1,39,1,39,1,39,1,39,1,39,1,39,1,39,1,39,1,40,1,40,1,40,1,40,1,40,
        1,40,1,41,1,41,1,42,1,42,1,42,1,42,1,42,1,43,1,43,1,43,1,43,1,43,
        1,43,1,44,1,44,1,44,1,44,1,44,1,44,1,44,1,45,1,45,1,45,1,45,1,45,
        1,45,1,46,1,46,1,46,1,46,1,46,1,46,1,46,1,46,1,46,1,46,1,46,1,46,
        1,46,1,46,1,46,1,46,1,47,1,47,1,47,1,47,1,47,1,47,1,47,1,47,1,47,
        1,47,1,47,1,47,1,47,1,47,1,47,1,47,1,48,1,48,1,48,1,48,1,48,1,48,
        1,48,1,48,1,48,1,48,1,48,1,48,1,48,1,48,1,49,1,49,1,49,1,49,1,49,
        1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,50,1,50,1,50,1,50,1,50,
        1,50,1,50,1,50,1,50,1,50,1,50,1,50,1,50,1,50,1,50,1,51,1,51,1,52,
        4,52,406,8,52,11,52,12,52,407,1,52,1,52,0,0,53,1,1,3,2,5,3,7,4,9,
        5,11,6,13,7,15,8,17,9,19,10,21,0,23,0,25,0,27,0,29,0,31,11,33,12,
        35,13,37,14,39,15,41,16,43,17,45,18,47,19,49,20,51,21,53,22,55,23,
        57,24,59,25,61,26,63,27,65,28,67,29,69,30,71,31,73,32,75,33,77,34,
        79,35,81,36,83,37,85,38,87,39,89,40,91,41,93,42,95,43,97,44,99,45,
        101,46,103,47,105,48,1,0,13,2,0,10,10,13,13,1,0,48,57,1,0,48,48,
        1,0,49,57,1,0,49,49,1,0,48,50,2,0,44,44,49,50,1,0,51,51,2,0,44,44,
        48,49,2,0,65,90,97,122,2,0,45,46,95,95,8,0,32,33,35,44,46,47,58,
        64,91,94,96,96,123,126,8217,8217,3,0,9,10,13,13,32,32,415,0,1,1,
        0,0,0,0,3,1,0,0,0,0,5,1,0,0,0,0,7,1,0,0,0,0,9,1,0,0,0,0,11,1,0,0,
        0,0,13,1,0,0,0,0,15,1,0,0,0,0,17,1,0,0,0,0,19,1,0,0,0,0,31,1,0,0,
        0,0,33,1,0,0,0,0,35,1,0,0,0,0,37,1,0,0,0,0,39,1,0,0,0,0,41,1,0,0,
        0,0,43,1,0,0,0,0,45,1,0,0,0,0,47,1,0,0,0,0,49,1,0,0,0,0,51,1,0,0,
        0,0,53,1,0,0,0,0,55,1,0,0,0,0,57,1,0,0,0,0,59,1,0,0,0,0,61,1,0,0,
        0,0,63,1,0,0,0,0,65,1,0,0,0,0,67,1,0,0,0,0,69,1,0,0,0,0,71,1,0,0,
        0,0,73,1,0,0,0,0,75,1,0,0,0,0,77,1,0,0,0,0,79,1,0,0,0,0,81,1,0,0,
        0,0,83,1,0,0,0,0,85,1,0,0,0,0,87,1,0,0,0,0,89,1,0,0,0,0,91,1,0,0,
        0,0,93,1,0,0,0,0,95,1,0,0,0,0,97,1,0,0,0,0,99,1,0,0,0,0,101,1,0,
        0,0,0,103,1,0,0,0,0,105,1,0,0,0,1,107,1,0,0,0,3,119,1,0,0,0,5,127,
        1,0,0,0,7,135,1,0,0,0,9,137,1,0,0,0,11,142,1,0,0,0,13,148,1,0,0,
        0,15,150,1,0,0,0,17,152,1,0,0,0,19,154,1,0,0,0,21,156,1,0,0,0,23,
        166,1,0,0,0,25,170,1,0,0,0,27,172,1,0,0,0,29,174,1,0,0,0,31,176,
        1,0,0,0,33,178,1,0,0,0,35,180,1,0,0,0,37,182,1,0,0,0,39,184,1,0,
        0,0,41,186,1,0,0,0,43,195,1,0,0,0,45,198,1,0,0,0,47,201,1,0,0,0,
        49,204,1,0,0,0,51,206,1,0,0,0,53,208,1,0,0,0,55,212,1,0,0,0,57,216,
        1,0,0,0,59,220,1,0,0,0,61,226,1,0,0,0,63,232,1,0,0,0,65,241,1,0,
        0,0,67,244,1,0,0,0,69,248,1,0,0,0,71,251,1,0,0,0,73,255,1,0,0,0,
        75,266,1,0,0,0,77,272,1,0,0,0,79,285,1,0,0,0,81,296,1,0,0,0,83,302,
        1,0,0,0,85,304,1,0,0,0,87,309,1,0,0,0,89,315,1,0,0,0,91,322,1,0,
        0,0,93,328,1,0,0,0,95,344,1,0,0,0,97,360,1,0,0,0,99,374,1,0,0,0,
        101,387,1,0,0,0,103,402,1,0,0,0,105,405,1,0,0,0,107,108,5,47,0,0,
        108,109,5,47,0,0,109,113,1,0,0,0,110,112,8,0,0,0,111,110,1,0,0,0,
        112,115,1,0,0,0,113,111,1,0,0,0,113,114,1,0,0,0,114,116,1,0,0,0,
        115,113,1,0,0,0,116,117,6,0,0,0,117,2,1,0,0,0,118,120,7,1,0,0,119,
        118,1,0,0,0,120,121,1,0,0,0,121,119,1,0,0,0,121,122,1,0,0,0,122,
        4,1,0,0,0,123,124,7,2,0,0,124,128,7,3,0,0,125,126,7,4,0,0,126,128,
        7,5,0,0,127,123,1,0,0,0,127,125,1,0,0,0,128,6,1,0,0,0,129,130,7,
        2,0,0,130,136,7,3,0,0,131,132,7,6,0,0,132,136,7,1,0,0,133,134,7,
        7,0,0,134,136,7,8,0,0,135,129,1,0,0,0,135,131,1,0,0,0,135,133,1,
        0,0,0,136,8,1,0,0,0,137,138,7,6,0,0,138,139,7,1,0,0,139,140,7,1,
        0,0,140,141,7,1,0,0,141,10,1,0,0,0,142,143,3,9,4,0,143,144,5,45,
        0,0,144,145,3,5,2,0,145,146,5,45,0,0,146,147,3,7,3,0,147,12,1,0,
        0,0,148,149,5,40,0,0,149,14,1,0,0,0,150,151,5,41,0,0,151,16,1,0,
        0,0,152,153,5,59,0,0,153,18,1,0,0,0,154,155,5,44,0,0,155,20,1,0,
        0,0,156,160,5,34,0,0,157,161,3,25,12,0,158,161,3,27,13,0,159,161,
        3,29,14,0,160,157,1,0,0,0,160,158,1,0,0,0,160,159,1,0,0,0,161,162,
        1,0,0,0,162,160,1,0,0,0,162,163,1,0,0,0,163,164,1,0,0,0,164,165,
        5,34,0,0,165,22,1,0,0,0,166,167,7,9,0,0,167,24,1,0,0,0,168,171,3,
        23,11,0,169,171,7,1,0,0,170,168,1,0,0,0,170,169,1,0,0,0,171,26,1,
        0,0,0,172,173,7,10,0,0,173,28,1,0,0,0,174,175,7,11,0,0,175,30,1,
        0,0,0,176,177,5,61,0,0,177,32,1,0,0,0,178,179,5,42,0,0,179,34,1,
        0,0,0,180,181,5,47,0,0,181,36,1,0,0,0,182,183,5,43,0,0,183,38,1,
        0,0,0,184,185,5,45,0,0,185,40,1,0,0,0,186,187,5,67,0,0,187,188,5,
        79,0,0,188,189,5,78,0,0,189,190,5,84,0,0,190,191,5,65,0,0,191,192,
        5,73,0,0,192,193,5,78,0,0,193,194,5,83,0,0,194,42,1,0,0,0,195,196,
        5,33,0,0,196,197,5,61,0,0,197,44,1,0,0,0,198,199,5,60,0,0,199,200,
        5,61,0,0,200,46,1,0,0,0,201,202,5,62,0,0,202,203,5,61,0,0,203,48,
        1,0,0,0,204,205,5,60,0,0,205,50,1,0,0,0,206,207,5,62,0,0,207,52,
        1,0,0,0,208,209,5,77,0,0,209,210,5,65,0,0,210,211,5,88,0,0,211,54,
        1,0,0,0,212,213,5,77,0,0,213,214,5,73,0,0,214,215,5,78,0,0,215,56,
        1,0,0,0,216,217,5,65,0,0,217,218,5,86,0,0,218,219,5,71,0,0,219,58,
        1,0,0,0,220,221,5,67,0,0,221,222,5,79,0,0,222,223,5,85,0,0,223,224,
        5,78,0,0,224,225,5,84,0,0,225,60,1,0,0,0,226,227,5,76,0,0,227,228,
        5,69,0,0,228,229,5,65,0,0,229,230,5,83,0,0,230,231,5,84,0,0,231,
        62,1,0,0,0,232,233,5,71,0,0,233,234,5,82,0,0,234,235,5,69,0,0,235,
        236,5,65,0,0,236,237,5,84,0,0,237,238,5,69,0,0,238,239,5,83,0,0,
        239,240,5,84,0,0,240,64,1,0,0,0,241,242,5,73,0,0,242,243,5,78,0,
        0,243,66,1,0,0,0,244,245,5,65,0,0,245,246,5,78,0,0,246,247,5,68,
        0,0,247,68,1,0,0,0,248,249,5,79,0,0,249,250,5,82,0,0,250,70,1,0,
        0,0,251,252,5,78,0,0,252,253,5,79,0,0,253,254,5,84,0,0,254,72,1,
        0,0,0,255,256,5,67,0,0,256,257,5,79,0,0,257,258,5,77,0,0,258,259,
        5,80,0,0,259,260,5,76,0,0,260,261,5,69,0,0,261,262,5,77,0,0,262,
        263,5,69,0,0,263,264,5,78,0,0,264,265,5,84,0,0,265,74,1,0,0,0,266,
        267,5,85,0,0,267,268,5,78,0,0,268,269,5,73,0,0,269,270,5,79,0,0,
        270,271,5,78,0,0,271,76,1,0,0,0,272,273,5,73,0,0,273,274,5,78,0,
        0,274,275,5,84,0,0,275,276,5,69,0,0,276,277,5,82,0,0,277,278,5,83,
        0,0,278,279,5,69,0,0,279,280,5,67,0,0,280,281,5,84,0,0,281,282,5,
        73,0,0,282,283,5,79,0,0,283,284,5,78,0,0,284,78,1,0,0,0,285,286,
        5,68,0,0,286,287,5,73,0,0,287,288,5,70,0,0,288,289,5,70,0,0,289,
        290,5,69,0,0,290,291,5,82,0,0,291,292,5,69,0,0,292,293,5,78,0,0,
        293,294,5,67,0,0,294,295,5,69,0,0,295,80,1,0,0,0,296,297,5,73,0,
        0,297,298,5,78,0,0,298,299,5,68,0,0,299,300,5,69,0,0,300,301,5,88,
        0,0,301,82,1,0,0,0,302,303,3,85,42,0,303,84,1,0,0,0,304,305,5,68,
        0,0,305,306,5,65,0,0,306,307,5,89,0,0,307,308,5,83,0,0,308,86,1,
        0,0,0,309,310,5,87,0,0,310,311,5,69,0,0,311,312,5,69,0,0,312,313,
        5,75,0,0,313,314,5,83,0,0,314,88,1,0,0,0,315,316,5,77,0,0,316,317,
        5,79,0,0,317,318,5,78,0,0,318,319,5,84,0,0,319,320,5,72,0,0,320,
        321,5,83,0,0,321,90,1,0,0,0,322,323,5,89,0,0,323,324,5,69,0,0,324,
        325,5,65,0,0,325,326,5,82,0,0,326,327,5,83,0,0,327,92,1,0,0,0,328,
        329,5,77,0,0,329,330,5,73,0,0,330,331,5,78,0,0,331,332,5,73,0,0,
        332,333,5,77,0,0,333,334,5,85,0,0,334,335,5,77,0,0,335,336,5,95,
        0,0,336,337,5,66,0,0,337,338,5,69,0,0,338,339,5,84,0,0,339,340,5,
        87,0,0,340,341,5,69,0,0,341,342,5,69,0,0,342,343,5,78,0,0,343,94,
        1,0,0,0,344,345,5,77,0,0,345,346,5,65,0,0,346,347,5,88,0,0,347,348,
        5,73,0,0,348,349,5,77,0,0,349,350,5,85,0,0,350,351,5,77,0,0,351,
        352,5,95,0,0,352,353,5,66,0,0,353,354,5,69,0,0,354,355,5,84,0,0,
        355,356,5,87,0,0,356,357,5,69,0,0,357,358,5,69,0,0,358,359,5,78,
        0,0,359,96,1,0,0,0,360,361,5,84,0,0,361,362,5,79,0,0,362,363,5,84,
        0,0,363,364,5,65,0,0,364,365,5,76,0,0,365,366,5,95,0,0,366,367,5,
        66,0,0,367,368,5,69,0,0,368,369,5,84,0,0,369,370,5,87,0,0,370,371,
        5,69,0,0,371,372,5,69,0,0,372,373,5,78,0,0,373,98,1,0,0,0,374,375,
        5,70,0,0,375,376,5,73,0,0,376,377,5,88,0,0,377,378,5,69,0,0,378,
        379,5,68,0,0,379,380,5,95,0,0,380,381,5,87,0,0,381,382,5,73,0,0,
        382,383,5,78,0,0,383,384,5,68,0,0,384,385,5,79,0,0,385,386,5,87,
        0,0,386,100,1,0,0,0,387,388,5,82,0,0,388,389,5,79,0,0,389,390,5,
        76,0,0,390,391,5,76,0,0,391,392,5,73,0,0,392,393,5,78,0,0,393,394,
        5,71,0,0,394,395,5,95,0,0,395,396,5,87,0,0,396,397,5,73,0,0,397,
        398,5,78,0,0,398,399,5,68,0,0,399,400,5,79,0,0,400,401,5,87,0,0,
        401,102,1,0,0,0,402,403,5,46,0,0,403,104,1,0,0,0,404,406,7,12,0,
        0,405,404,1,0,0,0,406,407,1,0,0,0,407,405,1,0,0,0,407,408,1,0,0,
        0,408,409,1,0,0,0,409,410,6,52,0,0,410,106,1,0,0,0,9,0,113,121,127,
        135,160,162,170,407,1,6,0,0
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!CommonLexer.__ATN) {
            CommonLexer.__ATN = new antlr.ATNDeserializer().deserialize(CommonLexer._serializedATN);
        }

        return CommonLexer.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(CommonLexer.literalNames, CommonLexer.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return CommonLexer.vocabulary;
    }

    private static readonly decisionsToDFA = CommonLexer._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}